// extracted by mini-css-extract-plugin
export var bottomImage = "FactCard-module--bottomImage--c3497";
export var cornerImage = "FactCard-module--cornerImage--69073";
export var factCard = "FactCard-module--factCard--614df";
export var textContent = "FactCard-module--textContent--0c066";
export var withCornerImage = "FactCard-module--withCornerImage--8b74f";